<script lang="ts">
	import type { ComponentProps } from 'svelte';
	import { ItineraryTrafficMode } from '$houdini';
	import AlertBox from '$lib/components/atoms/alertBox/AlertBox.svelte';
	import { ROUTE_RESULTS } from '$lib/constants/route';
	import { getSearchParamsStore, gotoWithParams } from '$lib/services/urls/searchParams';
	import * as m from '$paraglide/messages';

	interface Props {
		trafficDeviation: { title?: string | null; text: string };
	}

	const { trafficDeviation }: Props = $props();

	const searchParams = getSearchParamsStore();
	const withTrafficModeToNone = $derived($searchParams.traffic === ItineraryTrafficMode.NONE);
	const alertProps = $derived({
		color: withTrafficModeToNone ? 'red' : 'amber',
		title: trafficDeviation?.title ?? undefined,
		text: trafficDeviation!.text,
		buttonIcon: withTrafficModeToNone ? 'step-over' : 'east',
		buttonText: withTrafficModeToNone ? m.alert_itinerary__closed_roads__cta() : m.traffic_deviation__cta(),
	} satisfies ComponentProps<typeof AlertBox>);
</script>

<div class={withTrafficModeToNone ? 'px-2 w-full top--4 relative z-0' : 'pt-4 pb-2 px-2 md:pb-0 md:pt-2 w-full'}>
	<AlertBox
		{...alertProps}
		class="w-full text-coloredneutral"
		contentClass="justify-start"
		onclick={() => {
			gotoWithParams(ROUTE_RESULTS, {
				...$searchParams,
				traffic: withTrafficModeToNone ? ItineraryTrafficMode.CLOSINGS : ItineraryTrafficMode.NONE,
			});
		}}
	/>
</div>
